// Shared sidebar component for reuse
import React from "react";
import { Link } from "react-router-dom";
import { FiUser, FiShield } from "react-icons/fi";
import { useCurrentUser } from "../../hooks/useCurrentUser";

interface SidebarProps {
  user?: any;
  active?: string;
}

const navItems = [
  // { label: "Chat", path: "/dashboard", key: "dashboard" },
  { label: "Encounters", path: "/encounters", key: "encounters" },
  { label: "Patients", path: "/patients", key: "patients" },
  // { label: "Appointments", path: "/appointments", key: "appointments" },
  // { label: "Profile", path: "/profile", key: "profile" },
  // { label: "Reports", path: "/reports", key: "reports" },
  // { label: "Settings", path: "/settings", key: "settings" },
];

const adminNavItems = [
  { label: "Registrations", path: "/admin/registrations", key: "admin-registrations" },
  { label: "Doctors", path: "/admin/doctors", key: "admin-doctors" },
  { label: "Document Templates", path: "/admin/templates", key: "admin-templates" },
];

const Sidebar: React.FC<SidebarProps> = ({ user, active }) => {
  const { user: currentUser } = useCurrentUser();
  const isAdmin = currentUser?.is_staff ?? user?.is_staff ?? false;
  return (
  // shrink-0 keeps the rail at a constant width on every route; overflow-y-auto
  // keeps every item reachable instead of clipping them on short viewports.
  <aside className="w-64 shrink-0 bg-blue-700 text-white flex flex-col p-6 h-full overflow-y-auto">
{user && (
      <div className="flex items-center gap-2 bg-blue-800 px-3 py-2 rounded-lg mb-6">
        <div className="w-9 h-9 bg-blue-200 rounded-full flex items-center justify-center font-bold text-blue-700 text-lg">
          <FiUser className="w-6 h-6" />
        </div>
        <div className="flex flex-col">
          <span className="font-medium text-white">
            Dr. {user.first_name} {user.last_name}
          </span>
          <span className="text-xs text-blue-200 capitalize">
            {user.profile?.user_type}
          </span>
        </div>
      </div>
    )}
    <nav className="flex flex-col gap-2">
      {navItems.map((item) => (
        <Link
          key={item.key}
          to={item.path}
          className={`rounded px-3 py-2 transition font-medium ${
            active === item.key ? "bg-blue-900 text-white" : "hover:bg-blue-800"
          }`}
        >
          {item.label}
        </Link>
      ))}
    </nav>
    {isAdmin && (
      <div className="mt-auto pt-6">
        <div className="flex items-center gap-1.5 text-xs text-blue-300 uppercase tracking-wide font-semibold mb-2 px-1">
          <FiShield className="w-3 h-3" />
          Admin
        </div>
        <nav className="flex flex-col gap-1">
          {adminNavItems.map((item) => (
            <Link
              key={item.key}
              to={item.path}
              className={`rounded px-3 py-2 transition font-medium text-sm ${
                active === item.key ? "bg-blue-900 text-white" : "hover:bg-blue-800 text-blue-100"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>
      </div>
    )}
  </aside>
  );
};

export default Sidebar;
